export default __webpack_public_path__ + "static/media/down-chevron.0a6da113.svg";